import React, { Component } from 'react';
import { responseErrors } from '../../fetchUtils'
import { getNumericDateString } from '../../util'
import PropTypes from 'prop-types'
import _ from 'lodash';
import * as Sentry from '@sentry/browser';
import moment from 'moment';
import queries from './queries';
import AssignmentPopup from './AssignmentPopup';

//onboarding guide related import
import {OnboardingTeacherContext} from '../../contexts/OnboardingTeacherContextProvider'
import {convertTeacherStartTrack,convertStudentStartTrack, handleTaskComplete, status, step_id, handleSlackOnboarding} from '../../components/OnboardingHomepage/onboardingUtils'

class AssignmentPopupContainer extends Component {
  constructor(props){
    super(props);

    const selectedDateArray = props.assignableContent.type === 'sequences' ? new Array(props.assignableContent.quests.size) : []

    this.state = {
        isFetching: false,
        fetchError: [],
        isUpserting: false,
        upsertError: [],
        upsertedAssignmentObject: {},
        deleteErrors: [],
        deletedAssignments: [],
        selectedDateArray: selectedDateArray,
        selectedDateIndex: 0,
        selectedAssignees: [],
        formChanged: false,               // boolean used to track wether the form has been changed between submissions
        cachedFormValues: {},             //saved form values so that an upsertion request that requires a user decision can be resubmitted
        decisionArray: [],                //generated array that represents the user's decisions related to upsertion conflicts
        conflicts: [],                    //array of parsed assignment info data related to upsertion conflicts
        formattedUpsertionGroupInfo: '' , //JSON of assignment upsertion metadata relevant to the front end, sorted by assignee group
        showExpandableDetails: false,
        expandableDetails: [],            //array of formatted tables to represent the details of expandable content assigned to notifications
        currentDetailIndex: 0              //the currently selected notification reference for the expandableDetails array
    }
  };
  // Function used to clear the form-related state when the popup is closed.
  resetForm = () => {
    const selectedDateArray = this.props.assignableContent.type === 'sequences' ? new Array(this.props.assignableContent.quests.size) : []
    this.setState({ isUpserting: false,
        upsertedAssignmentObject: {},
        deleteErrors: [],
        upsertError: [],
        deletedAssignments: [],
        selectedDateArray: selectedDateArray,
        selectedDateIndex: 0,
        selectedAssignees: [],
        cachedFormValues: {},
        conflicts: [],
        formattedUpsertionGroupInfo: '',
        showExpandableDetails: false,
        expandableDetails: [],
        formChanged: false
    })
  }

  //onboarding related imports
  static contextType = OnboardingTeacherContext
  // Function that is called on submission of the upsertion form, that sends a request to the graphql mutation,
  // calls the related parsing functions, and saves the parsed results to the state
  handleUpsertAssignments = (formValues, onSuccess, decisionArray = []) => {
    if(_.isEmpty(formValues)){ return }
    this.setState({ isUpserting: true, upsertError: [], showExpandableDetails: false, expandableDetails: [], currentDetailIndex: 0 })
    const variables = formValues.variables
    if(!_.isEmpty(decisionArray)){ variables["resolutions"] = decisionArray}
    const callbacks = {
      onComplete: json => {
        const errors = responseErrors(json)
        if(_.isEmpty(errors)) {
          if(_.isFunction(onSuccess)){ onSuccess() }
          this.setState((state)=>{
            let conflict = ""
            if(!_.isEmpty(json['data']['upsertAssignments']['conflict'])){ conflict = JSON.parse(json['data']['upsertAssignments']['conflict'])}
            const successDetails = this.setSuccessDetails(json['data']['upsertAssignments'])
              return {
                upsertedAssignmentObject: json['data']['upsertAssignments'],
                isUpserting:false,
                conflicts: _.isEmpty(conflict) ? "" : [conflict],
                formattedUpsertionGroupInfo: json['data']['upsertAssignments']['formattedGroupInfo'],
                cachedFormValues: formValues,
                decisionArray: decisionArray,
                formChanged: false
          }})

          //updating onboarding guide context when assignment task is completed
          if(!this.context.isAllComplete ){
            //teacher onboarding assignment to self task
            if(formValues.variables.userAssignment && this.context.teacherStartTrack.steps.assignYourself !== _.indexOf(status,'completed')){
              const updateOnboardingCred = {
                stepId:_.indexOf(step_id,'hasSelfAssigned')
              }

              const updateOnboardingTaskComplete = {
                onComplete: json => {
                  const errors = json.data.completeOnboardingStep.updatedContext.errors
                  if(!_.isEmpty(errors)){
                    errors.map(error => console.error(error))
                  }
                  else {
                    const data = json.data.completeOnboardingStep.updatedContext
                    const teacherTrackUpdate = convertTeacherStartTrack(data)
                    
                    this.context.setTeacherStartTrack(prev => {
                      /*in the case that assign to self is skipped, and is the last to be completed, the following 
                      if statement should check for if this sequence was previously marked as completed, and if not 
                      send a slack notification*/
                      if (data.personalOnboardingStepsCompleted && !prev.isPersonalOnboardingCompleted) {
                        handleSlackOnboarding(this.context.current_user, `${data.classOnboardingStepsCompleted ? 'both sequences' : 'Self-Assign Sequence'}`)
                      }
        
                      return {
                      ...prev,
                      completedSteps:this.context.teacherStartTrack.completedSteps + 1,
                      ...teacherTrackUpdate
                      }
                    })
                    this.context.setIsAllComplete(data.allOnboardingStepsCompleted)

                    //setting current path for banner to show teacher path if not completed
                    if(teacherTrackUpdate.isPersonalOnboardingCompleted){
                      this.context.setCurrentPath('teacher_studentStartPath')
                    }
                    else{
                      this.context.setCurrentPath('teacher_selfStartPath')
                    }                    
                  }
                },
                onFailure: error => {console.error(error)}
              }

              handleTaskComplete(updateOnboardingTaskComplete,updateOnboardingCred)
            }
            //teacher onboarding assignment to student task
            if(this.context.studentStartTrack.steps.assignToStudent !== _.indexOf(status,'completed') && (!_.isEmpty(formValues.variables.sectionIds) || !_.isEmpty(formValues.variables.studentIds))){                       
              const updateOnboardingCred = {
                stepId:_.indexOf(step_id,'hasCreatedStudentAssignment')
              }

              const updateOnboardingTaskComplete = {
                onComplete: json => {
                  const errors = json.data.completeOnboardingStep.updatedContext.errors
                  if(!_.isEmpty(errors)){
                    errors.map(error => console.error(error))
                  }
                  else{
                    const data = json.data.completeOnboardingStep.updatedContext
                    const studentTrackUpdate = convertStudentStartTrack(data)
                    this.context.setStudentStartTrack(prev => {
                      if (data.classOnboardingStepsCompleted && !prev.isClassOnboardingCompleted) {
                        handleSlackOnboarding(this.context.current_user, `${data.personalOnboardingStepsCompleted ? 'both sequences' : 'Student Sequence'}`)
                      }
                      return {
                      ...prev,
                      completedSteps:this.context.studentStartTrack.completedSteps + 1,
                      ...studentTrackUpdate
                      }
                    })
                    this.context.setIsAllComplete(data.allOnboardingStepsCompleted)

                    //setting current path for banner to show student path if not completed
                    if(studentTrackUpdate.isClassOnboardingCompleted){
                      this.context.setCurrentPath('teacher_selfStartPath')
                    }
                    else{
                      this.context.setCurrentPath('teacher_studentStartPath')
                    }     
                  }
                },
                onFailure: error => {console.error(error)}
              }

              handleTaskComplete(updateOnboardingTaskComplete, updateOnboardingCred)
            }
          }

        } else {
          this.setState({ upsertError: errors, isUpserting: false, formChanged: false });
        }
      },
      onFailure: ()=>{
        this.setState({ upsertError: ['Sorry, something went wrong!'], isUpserting: false, formChanged: false });
      }
    }
    queries.upsertAssignments(callbacks, variables)
  }
  // Function called when the bulk deletion form is submitted.
  handleDeleteAssignments  = (formValues) => {
    this.setState({ isDeleteing: true, deleteErrors: [] })
    if (formValues.variables.assignmentIds.length < formValues.variables.studentGroupings.length) {
      this.setState({ deleteErrors: ['One or more of the specified assignees are not assigned to this content.'] })
    } else {
      const variables = { ids: formValues.variables.assignmentIds }
      const callbacks = {
        onComplete: json => {
          const errors = json.errors ? json.errors : json.data.deleteAssignments.errors
          if(_.isEmpty(errors)) {
            this.setState({isDeleting: false, deletedAssignments: json.data.deleteAssignments.deletedAssignments})
          } else {
            this.setState({deleteErrors: errors})
          }
        },
        onFailure: errors => this.setState({ deleteErrors: [errors]})
      }
      queries.deleteAssignments(callbacks, variables)
    }
  }
  // Function that parses the raw form values to be submitted to the graphql upsertion mutation.
  parsedUpsertionFormData = (values)=> {
    let parsedData = _.cloneDeep(values)
    let { assignmentTimestamps, studentGroupings } = parsedData
    const { assignableContent } = this.props
    let timestamps = []
    if(_.filter(assignmentTimestamps, t=>{return _.isEmpty(t)}).length > 0){
      this.setState({upsertError:['Please submit the correct number of assignment dates']})
      return
    } else {
    //ensure all timestamps are in iso8601 format, with only date information.
      try {
        timestamps = _.map(assignmentTimestamps, time=>(new Date(time).toISOString().split('T')[0]) + "T00:00:00.000Z")
      }
      catch (err) {
        Sentry.withScope(function(scope) {
          scope.setExtra('Exception encountered when trying to parse timestamps:', assignmentTimestamps);
          Sentry.captureException(err);
        });
      }
    }

    // Convert the hacky way groupings are stored in the form into a list of StudentGrouping objects
    // that the server can accept.
    let variables = {studentIds: [], sectionIds: [], timestamps: timestamps, userAssignment: false}
    switch(this.props.assignableContent.type) {
      case 'sequences':
        variables.sequenceId = _.toNumber(assignableContent.id);
        break;
      case 'quests':
      case 'modules':
        variables.questId = assignableContent.id;
        break;
    }
    _.each(studentGroupings, grouping=>{
      if(grouping === 'myself') {
        variables.userAssignment = true
      } else {
        variables[`${grouping.match(/([a-zA-Z]+)(\d+)/)[1]}Ids`].push(parseInt(grouping.match(/([a-zA-Z]+)(\d+)/)[2]))
      }
    })
    return { variables: variables }
  }

  //Function that parses the raw deletion form data into values that can be accepted by the deletion mutation
  parsedDeletionFormData = (formValues) => {
    const { sidebarAssignments, assignableContent } = this.props
    const selectedClassAssignments= sidebarAssignments.selectedClassAssignments
    const individualAssignmentGrouping = sidebarAssignments.selectedIndividualAssignments.concat(_.flattenDeep(selectedClassAssignments))
    let parsedData = _.cloneDeep(formValues)
    let { studentGroupings } = parsedData
    // Convert the hacky way groupings are stored in the form into a list of StudentGrouping objects
    // that the server can accept.
    let newGroupingObj = {}
    parsedData.studentGroupingsAttributes = _.map(studentGroupings, grouping=>{
      newGroupingObj = {}

      if(grouping === 'myself') {
        newGroupingObj.myself = true
      } else {
        newGroupingObj[`${grouping.match(/([a-zA-Z]+)(\d+)/)[1]}_id`] = grouping.match(/([a-zA-Z]+)(\d+)/)[2]
      }

      return newGroupingObj
    })
    let associatedAssignmentIds = []
    let associatedSectionAssignments = []

    _.map(parsedData.studentGroupingsAttributes, studentGrouping => {
      if(Object.keys(studentGrouping)[0] === "section_id") {
        _.map(selectedClassAssignments, course => {
          _.map(course, classAssignment => {
            if(classAssignment[0].sectionId  === parseInt(studentGrouping.section_id)){
              associatedSectionAssignments = _.map(classAssignment, assignment => assignment.id)
            }
          })
        })
        if(!_.isEmpty(associatedSectionAssignments)) {
          associatedAssignmentIds = associatedAssignmentIds.concat(associatedSectionAssignments)
        }
      } else if(studentGrouping.myself) {
        _.each(sidebarAssignments.selectedSelfAssignments, assignment => associatedAssignmentIds.push(assignment.id))
      } else {
        const foundAssignment = _.find(individualAssignmentGrouping, assignment =>
          assignment.studentId === parseInt(studentGrouping.student_id) && assignment.questId === parseInt(assignableContent.id)
        )
        if(!_.isEmpty(foundAssignment)) { associatedAssignmentIds.push(foundAssignment.id) }
        }
    })

    parsedData.assignmentIds = associatedAssignmentIds || []

    return { variables: parsedData }
  }

  //Calendar's onClick method for selecting a date
  setSelectedDate = (date)=>{
    let newSelectedDateArray = this.state.selectedDateArray
    newSelectedDateArray[this.state.selectedDateIndex] = moment(date).utc().startOf('day').format('M/D/YYYY')
    this.setState({ selectedDateArray: newSelectedDateArray, formChanged: true })
  }

  //the text field's onChange method for selecting a date
  checkTextDate = (e)=>{
    const potentialDateString = moment(e.target.value).format('M/D/YYYY')

    const selectedIndex = parseInt(new RegExp(/\d+/g).exec(e.target.id)[0])
    let newSelectedDateArray = [...this.state.selectedDateArray]
    newSelectedDateArray[selectedIndex] = moment(e.target.value, 'M/D/YYYY').format('M/D/YYYY')

    if ((!_.isEqual(potentialDateString , this.state.selectedDateArray[selectedIndex])) && moment(e.target.value,'M/D/YYYY',true )._isValid){
      this.setState({ selectedDateArray: newSelectedDateArray, selectedDateIndex: selectedIndex, formChanged: true })
    }
  }
  //onChange method for AssigneeGroupings, for use in noting when the form is changed between submissions
  onAssigneeChange = ()=>{
   this.setState({formChanged: true})
  }

  //updating the index on focus of a text input
  setSelectedIndex = (e) => {
    const selectedIndex = new RegExp(/\d+/g).exec(e.target.id)[0]
    this.setState({ selectedDateIndex: selectedIndex })
  }

  // The general onSubmit function for the bulk upsertion form. Calls the upsertion handler method and the form parsing method if there are no notifications to resolve
  onSubmitUpsertion = (values) => {
    const { fetchCalendarData } = this.props
    //WE check to see if decisionNotifications is empty so that this on submit function can defer to the resolve notifications function for upserting on the assignment form.
    if ( _.isEmpty(this.state.conflicts)){
      this.handleUpsertAssignments(this.parsedUpsertionFormData(values), fetchCalendarData)
    }
  }
  // the onSubmit function for the bulkDeletion form. calls the deletion mutation handler function as long as there are submitted student groupings
  onSubmitDeletion = (values) => {
    const formattedValues = this.parsedDeletionFormData(values)
    if(_.isEmpty(formattedValues.variables.studentGroupings)){
      this.setState({deleteErrors: ['Must specify at least one assignee.']})
    } else {
      this.handleDeleteAssignments(formattedValues)
    }
  }

  //Functions that have to do with the assignment notification system:

  //this depreciated function converted notification strings related to non-conflict notifications into notification components
  /*
  getNotificationMessages = (notificationString)=> {
    if(_.isEmpty(notificationString)){ return [] }

    let notificationJson
    try{
      notificationJson = JSON.parse(notificationString)
    } catch(e){
      console.error("error when parsing notification string: ", e)
      return [ <div className='notification'>Something Went Wrong!</div> ]
    }

    let nonDecisionNotificationJson = _.omit(notificationJson, ["classToIndividualStandaloneDiffDate",
                                                                "classToIndividualStorylineDiffDate",
                                                                "individualToClassStorylineDiffDate",
                                                                "individualToClassStandaloneDiffDate"])

    let nonDecisionNotificationsPopulated = !_.isEmpty(_.concat(Object.values(nonDecisionNotificationJson)).flat())
    if(nonDecisionNotificationsPopulated){
      let notificationArray = _.map(nonDecisionNotificationJson, (value, key)=>{
        let studentNames = _.map(value, assn => assn.student_name)

        if(!_.isEmpty(value)){switch(key){
          case "classToIndividualSameDate":
            return(
              <div className='notification'>
                No new assignment(s) created for <b>{studentNames.join(' ')}</b>, because their class was already assigned to this content queued on <b>{value[0].to_be_assigned_at}</b>
              </div>
            )
            break;
          case "overlappedStudents":
            return(
              <div className='notification'>
                <b>{studentNames.join(' ')}</b> are only assigned to each quest once with their classes
              </div>
            )
            break;
          default:
            console.error("notification parser was submitted type that is unrecognized: ", key)
            break;
        }}
      })
      return _.compact(notificationArray)
    } else {
      return []
    }
  }
  */

  // Function that takes in a conflict and associated components and formats the data to be shown as expandableDetails
  setExpandableDetails = (conflictType, components) => {
    if(_.isEmpty(components)){ return }
    let detailComponent
    // Function that takes a list of sorted names and associated component, and returns an array of formatted expanded detail row react components.
    // moved out of the switch statement to reduce repeated code.
    const formatStartedCompletedDetailRows = (sortedNames, component) => {
      return _.map(sortedNames, name => {
        let assocAssi
        if(!_.isEmpty(component.section)){
          const assocPairs = Object.entries(component.group_name_id_pairs)
          const studentId = _.find(assocPairs, pair => pair[1] == name)[0]
          assocAssi = _.find(component.assignments, a=>a.student_id == studentId)
        } else if(!_.isEmpty(component.student)){
          assocAssi = _.find(component.assignments, a=>a.student_id == component.student.id)
        } else {
          assocAssi = _.find(component.assignments, a=>a.user_id == component.user.uuid)
        }
        const startedCompletedDate = assocAssi.completed_at || assocAssi.started_at
        const startedCompletedString = assocAssi.completed_at ? "completed on " : "started on "
        return <div className='detail-contents-row'>
          <div className='column-one'>{name}</div>
          <div className='column-two'>{startedCompletedString + getNumericDateString(new Date(startedCompletedDate))}</div>
        </div>
      })
    }
    const formatDiffDateDetailRows = (sortedNames, component) => {
      return _.map(sortedNames, name => {
        let assocAssi
        if(!_.isEmpty(component.section)){
          const assocPairs = Object.entries(component.group_name_id_pairs)
          const studentId = _.find(assocPairs, pair => pair[1] == name)[0]
          assocAssi = _.find(component.assignments, a=>a.student_id == studentId)
        } else if(!_.isEmpty(component.student)){
          assocAssi = _.find(component.assignments, a=>a.student_id == component.student.id)
        }
        if(_.isEmpty(assocAssi)){ return }
        return <div className='detail-contents-row'>
          <div className='column-one'>{name}</div>
          <div className='column-two'>{"queued on " + getNumericDateString(new Date(assocAssi.to_be_assigned_at))}</div>
        </div>
      })
    }

    switch(conflictType){
      case "PartialPriorProgress": case "FullPriorProgress":
        if(components[0].is_storyline){
          const byQuest = _.groupBy(components, c => c.quest.id)
          detailComponent = _.map(byQuest, (components, questId) => {
            const component = components[0]
            let names = []
            if(_.isEmpty(component.group_name_id_pairs)){
              names = [component.full_name]
            }else{
              const associatedIds = _.map(component.assignments, a=>{return a.student_id})
              names = _.map(associatedIds, i=>{return component.group_name_id_pairs[i]})
            }
            const sortedNames = _.sortBy(names, name => name)
            const rowComponents = formatStartedCompletedDetailRows(sortedNames, component)
            return <div className='detail-subrow'>
              <div className='detail-header'><b>{component.quest.name}</b></div>
              {rowComponents}
            </div>
          })
        } else {
          const component = components[0]
          let names = []
          if(_.isEmpty(component.group_name_id_pairs)){
            names = [component.full_name]
          }else{
            const associatedIds = _.map(component.assignments, a=>{return a.student_id})
            names = _.map(associatedIds, i=>{return component.group_name_id_pairs[i]})
          }
          const sortedNames = _.sortBy(names, name => name)
          detailComponent = formatStartedCompletedDetailRows(sortedNames, component)
        }
      break;
      case "IndividualToClassDiffDate": case "ClassToIndividualDiffDate" :
        if(components[0].is_storyline){
          const byQuest = _.groupBy(components, c => c.quest.id)
          detailComponent = _.map(byQuest, (components, questId) => {
            const component = components[0]
            const associatedIds = _.map(component.assignments, a=>{return a.student_id})
            let names = []
            if(_.isEmpty(component.group_name_id_pairs)){
              names = [component.full_name]
            }else{
              const associatedIds = _.map(component.assignments, a=>{return a.student_id})
              names = _.map(associatedIds, i=>{return component.group_name_id_pairs[i]})
            }
            const sortedNames = _.sortBy(names, name => name)
            const rowComponents = formatDiffDateDetailRows(sortedNames, component)
            return <div className='detail-subrow'>
              <div className='detail-header'><b>{component.quest.name}</b></div>
              {rowComponents}
            </div>
          })
        } else {
          const component = components[0]
          const associatedIds = _.map(component.assignments, a=>{return a.student_id})
          let names = []
          if(_.isEmpty(component.group_name_id_pairs)){
            names = [component.full_name]
          }else{
            const associatedIds = _.map(component.assignments, a=>{return a.student_id})
            names = _.map(associatedIds, i=>{return component.group_name_id_pairs[i]})
          }
          const sortedNames = _.sortBy(names, name => name)
          detailComponent = formatDiffDateDetailRows(sortedNames, component)
        }
      break;
    }
    if(this.state.showExpandableDetails && _.isEqual(detailComponent, this.state.expandableDetails)){
      this.setState({ showExpandableDetails: false})
    } else if(this.state.showExpandableDetails) {
      this.setState({ expandableDetails: detailComponent})
    } else {
      this.setState({ showExpandableDetails: true, expandableDetails: detailComponent})
    }
  }

  //this function converts the inputted conflict-object into a readable component for the popup, with links to the associated expandableDetails
  getConflictMessage = (conflict) => {
    const conflictType = conflict.type

    let messageComponent
    const classComponents = _.groupBy(_.filter(conflict.components, c => !_.isEmpty(c.section)), c=> c.section.id)
    const studentComponents = _.groupBy(_.filter(conflict.components, c => !_.isEmpty(c.student)), c=> c.student.id)
    const userComponents = _.groupBy(_.filter(conflict.components, c => !_.isEmpty(c.user)), c=> c.user.id)
    const individualComponents = { ...studentComponents, ...userComponents } //key is ids vals are components
    const assigneeLength = Object.keys(classComponents).length + Object.keys(individualComponents).length
    let formattedClassComponents = []
    let formattedStudentComponent = []
    let formattedSelfComponent = []
    let combinedFormattedComponents = []
    let affectedEnrollments = []
    let classEnrollments = []
    // function that takes the current message array, combines and returns a string relevant to PartialPriorProgress and FullPriorProgress
    // this was made into a separate function as the formatting was similar to both previously mention conflict messages
    const formatStartedCompletedEndOfMessage = (messageLength, is_storyline) => {
      let message = ""
      if(messageLength > 0){
        message = message.concat(" " + (messageLength > 1 ? "have ": "has "))
        // adding the next segment based on if the assigned content is an storylione or not
        if(is_storyline){
          message = message.concat("started or completed some of the quests.")
        } else {
          message = message.concat("started or completed the quest.")
        }
        message = message.concat(" They will have to start over if you re-assign to them.")
      } else {
        console.log('error when generating a conflict message!')
      }
      return message
    }

    switch(conflictType){
      case "IndividualToClassDiffDate" :
        //Step1: Create Section react component links
        _.each(classComponents,(components, sectionId) => { //key is class id, val is array of components associted with that section
          affectedEnrollments = _.uniq(_.flatMap(components, c=>{return _.map(c.assignments, a=>{return a.student_id})}))
          const affectedEnrollmentSize = affectedEnrollments.length
          const sectionName = components[0].section.name
          let classComponent = [
              <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, components)}><b>{affectedEnrollmentSize + " student" + (affectedEnrollmentSize > 1 ? "s" : "")}</b></div>,
              " in class ",
              <b>{sectionName}</b>
          ]
          if(formattedClassComponents.length < Object.keys(classComponents).length - 1){
            classComponent.push(", ")
          }

          formattedClassComponents.push(classComponent)
        })

        combinedFormattedComponents = [<div className='expandable-title-container'>{formattedClassComponents}</div>]
        messageComponent = <div className='notification'>{combinedFormattedComponents}{" are currently assigned to " + (conflict.components[0].is_storyline ? "some of the quests" : "this quest") + " queued on a different date. Do you want to merge them with the class?"}</div>
      break;

      case "ClassToIndividualDiffDate" :
        //Step 1: Create individual student react component
        if(!_.isEmpty(studentComponents)){
          formattedStudentComponent = <div className='expandable-title-container'>{_.map(Object.entries(studentComponents), (values, index)=>{ //0 is id, 1 is components in values
            return <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, values[1])}><b>{values[1][0].full_name + (index + 1 < Object.entries(studentComponents).length ? ", " : " ")}</b></div>
          })}</div>
        }
        //Step 2: Combine components
        combinedFormattedComponents = [<div className='expandable-title-container'>{formattedStudentComponent}</div>]
        //Step 3: add the rest of the formatting to the message
        messageComponent = <div className='notification'>{combinedFormattedComponents}{(Object.keys(studentComponents).length > 1 ? 'are' : 'is') +" currently assigned to this quest queued on a different date with their class. Are you sure you want to separate their assignments from the class?"}</div>
      break;

      case "PartialPriorProgress" :
        //Step 1a: Create Section react component links
        _.each(classComponents,(components, sectionId) => { //key is class id, val is array of components associted with that section
          affectedEnrollments = _.uniq(_.flatMap(components, c=>{_.map(c.assignments, a=>{return a.student_id})}))
          const affectedEnrollmentSize = affectedEnrollments.length
          const sectionName = components[0].section.name
          let classComponent = [
              <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, components)}><b>{affectedEnrollmentSize + " student" + (affectedEnrollmentSize > 1 ? "s" : "")}</b></div>,
              " in class ",
              <b>{sectionName}</b>
          ]
          if(formattedClassComponents.length < Object.keys(classComponents).length - 1){
            classComponent.push(", ")
          }

          formattedClassComponents.push(classComponent)
        })
        //Step 1b: Create individual student react component
        if(!_.isEmpty(studentComponents)){
          formattedStudentComponent = <div className='expandable-title-container'>{_.map(Object.entries(studentComponents), (values, index)=>{ //0 is id, 1 is components in values
            return <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, values[1])}><b>{values[1][0].full_name + (index + 1 < Object.entries(studentComponents).length ? ", " : " ")}</b></div>
          })}</div>
        }
        //Step 1c: Create user component
        if(!_.isEmpty(userComponents)){
          formattedSelfComponent = <div className='expandable-title-container'>{_.map(Object.entries(userComponents), (values, index)=>{ //0 is id, 1 is components in values
            return <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, values[1])}><b>you</b></div>
          })}</div>
        }
        //Step 2: Combine components
        if(!_.isEmpty(classComponents)){ combinedFormattedComponents = [<div className='expandable-title-container'>{formattedClassComponents}</div>] }
        if(!_.isEmpty(combinedFormattedComponents) && !_.isEmpty(studentComponents)){
          if(!_.isEmpty(userComponents)){ combinedFormattedComponents.push(", ") }
          else{ combinedFormattedComponents.push(" and ") }
        }
        if(!_.isEmpty(studentComponents)){combinedFormattedComponents.push(formattedStudentComponent)}
        if(!_.isEmpty(combinedFormattedComponents) && !_.isEmpty(userComponents)){
          if(!_.isEmpty(classComponents) && !_.isEmpty(studentComponents)){ combinedFormattedComponents.push(", and ")}
          else{ combinedFormattedComponents.push("and ") }
        }
        if(!_.isEmpty(userComponents)){combinedFormattedComponents.push(formattedSelfComponent)}
        //Step 3: add the rest of the formatting to the message

        messageComponent = <div className='notification'>{combinedFormattedComponents}{formatStartedCompletedEndOfMessage(assigneeLength, conflict.components[0].is_storyline) + " Do you want to only assign to the other students?"}</div>
      break;

      case "FullPriorProgress" :
        //Step 1a: Create Section react component links
        _.each(classComponents,(components, sectionId) => { //key is class id, val is array of components associted with that section
          const sectionName = components[0].section.name
          const classComponent = [
            <b>{(formattedClassComponents.length == 0 ? "A" : "a") + "ll students"}</b>,
            " in class ",
            <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, components)}><b>{sectionName}</b></div>
          ]

          if(formattedClassComponents.length < Object.keys(classComponents).length - 1){
            classComponent.push(", ")
          }
          formattedClassComponents.push(classComponent)
        })
        //Step 1b: Create individual student react component
        if(!_.isEmpty(studentComponents)){
          formattedStudentComponent = <div className='expandable-title-container'>{_.map(Object.entries(studentComponents), (values, index)=>{ //0 is id, 1 is components in values
            return <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, values[1])}><b>{values[1][0].full_name + (index + 1 < Object.entries(studentComponents).length ? ", " : " ")}</b></div>
          })}</div>
        }
        //Step 1c: Create individual self react component
        if(!_.isEmpty(userComponents)){
          formattedSelfComponent = <div className='expandable-title-container'>{_.map(Object.entries(userComponents), (values, index)=>{ //0 is id, 1 is components in values
            return <div className='expandable-title' onClick={()=>this.setExpandableDetails(conflictType, values[1])}><b>you</b></div>
          })}</div>
        }

        //Step 2: Combine classComponents and individualComponents
        if(!_.isEmpty(classComponents)){ combinedFormattedComponents = [<div className='expandable-title-container'>{formattedClassComponents}</div>] }
        if(!_.isEmpty(combinedFormattedComponents) && !_.isEmpty(studentComponents)){
          if(!_.isEmpty(userComponents)){ combinedFormattedComponents.push(", ") }
          else{ combinedFormattedComponents.push(" and ") }
        }
        if(!_.isEmpty(studentComponents)){combinedFormattedComponents.push(formattedStudentComponent)}
        if(!_.isEmpty(combinedFormattedComponents && !_.isEmpty(userComponents))){
          combinedFormattedComponents.push(" and ")
        }
        if(!_.isEmpty(userComponents)){combinedFormattedComponents.push(formattedSelfComponent)}
        //Step 3: add the rest of the formatting to the message
        messageComponent = <div className='notification'>{combinedFormattedComponents}{formatStartedCompletedEndOfMessage(assigneeLength, conflict.components[0].is_storyline) + " Are you sure you want to re-assign to them?"}</div>
      break;
    }
    return messageComponent
  }

  //This function takes the decision-input from the user on a particular assignment conflict and converts it to a decison object to be sent in the
  //upsertion mutation when all decisions have been made.
  resolveDecision = (key, decision) => {
    const { fetchCalendarData } = this.props
    let newDecisions = _.cloneDeep(this.state.decisionArray)
    let newConflictQueue = _.cloneDeep(this.state.conflicts)
    newDecisions.push(decision)
    newConflictQueue.shift()

    if (_.isEmpty(newConflictQueue)){
      //The new Decision Object is passed instead of set in state because there is no guarantee timewise when the state is set successfully.
      this.handleUpsertAssignments(this.state.cachedFormValues, fetchCalendarData, newDecisions)
    } else {
      this.setState({ conflicts: newConflictQueue, decisionArray: newDecisions })
    }
  }

  //method to set the expandableDetails of the success notifications
  setSuccessDetails = (classGroup) => {
    const classAssignments = classGroup.group_assignments

    if(_.isEmpty(classAssignments)) {return }

    let groupedClassAssignments
    let groupedClassArray
    let sortedClassAssignments
    let splitStudentDetails = []

    splitStudentDetails = _.flatMap(Object.entries(classAssignments), (assignment, index) => <div className='detail-row'>
      <div className='detail-header'><b>{classGroup.quests_hash[assignment[0]]}</b></div>
        {_.map(assignment[1], assignmentInfo => <div className='detail-subrow'>
          <div className='detail-contents-row'>
            <div className='column-one'>{classGroup.section_assignee_name_hash[assignmentInfo.student_id]}</div><div className='column-two'>queued on {getNumericDateString(new Date(assignmentInfo.to_be_assigned_at))}</div>
          </div>
        </div>)}
      </div>)

    if(this.state.showExpandableDetails && _.isEqual(splitStudentDetails, this.state.expandableDetails)){
      this.setState({ showExpandableDetails: false})
    } else if(this.state.showExpandableDetails) {
      this.setState({ expandableDetails: splitStudentDetails})
    } else {
      this.setState({ showExpandableDetails: true, expandableDetails: splitStudentDetails})
    }

  }

  //resetNotifications - onclick method to clear decisions, cache and notifications so user can update proposed assignment values
  resetNotifications = ()=>{
    this.setState({conflicts: [], cachedFormValues: {}, decisionArray: {}, expandableDetails: [], showExpandableDetails: false})
  }

  //method for formatting assignment data into a success message on the form
  getSuccessMessage = (formattedGroupInfo)=> {
    const parsedGroups = JSON.parse(formattedGroupInfo)
    const uniqueQuestCount = (parsedGroups[0].quest_size <= 0 ? 1 : parsedGroups[0].quest_size) //if quest size is zero, its a sandbox unlock
    const individualGroups = _.filter(parsedGroups, (g)=>g.group_type == 'Student')
    const classGroups      = _.filter(parsedGroups, (g)=>g.group_type == 'Section' )

    const hasSelfAssignment = !_.isEmpty(_.filter(parsedGroups, (g)=>g.group_type == 'User'))
    const hasClassAssignments = !_.isEmpty(classGroups)
    const hasIndividualAssignments = !_.isEmpty(individualGroups)
    const hasSeparatedAssignments = !_.isEmpty(_.filter(classGroups, (g)=>g.separated_assignments))

    const classAssignmentClassesCount = classGroups.length
    const individualStudentCount = individualGroups.length

    let classCountArray = []
      if(hasSeparatedAssignments){
      _.each(classGroups, (group, index)=>{
        let amountString = group.separated_assignments ? "some" : "all"

        classCountArray = classCountArray.concat([
          <div className='expandable-title' onClick={()=>this.setSuccessDetails(group)}><b>{amountString + " of the students"}</b></div>,
          " in ",
          <b>{group.group_name}</b>
        ])
        if(index + 1 < classGroups.length ){ classCountArray.push(", ")}
      })
      } else {
            classCountArray = [<b>{classAssignmentClassesCount + " class" + (classAssignmentClassesCount > 1 ? "es":"")}</b>]
      }



    const questCountString = uniqueQuestCount + " assignment" + (uniqueQuestCount > 1 ? "s":"" )
    const individualStudentString = individualStudentCount + " individual student" + (individualStudentCount > 1 ? "s" : "")
    const selfAssignmentArray = [<b>yourself</b>, ". You will see your self-assignments when you enter ", <b>Tyto Public World</b>, " upon class selection."]

    let messageArray = [<b>{questCountString}</b>, " created/updated for "]

    if(hasClassAssignments){
      messageArray = messageArray.concat(classCountArray)

      if(hasIndividualAssignments){
        if(hasSelfAssignment){
          messageArray = messageArray.concat([", ", <b>{individualStudentString}</b>,", and "])
          messageArray = messageArray.concat(selfAssignmentArray)
        } else {
          messageArray = messageArray.concat([" and ", <b>{individualStudentString}</b>])
        }
      } else if(hasSelfAssignment){
        messageArray.push(" and ")
        messageArray = messageArray.concat(selfAssignmentArray)
      }
    } else if(hasIndividualAssignments){
      messageArray.push(<b>{individualStudentString}</b>)

      if(hasSelfAssignment){
        messageArray.push(" and ")
        messageArray = messageArray.concat(selfAssignmentArray)
      }
    } else if(hasSelfAssignment){
      messageArray = messageArray.concat(selfAssignmentArray)
    } else {
      messageArray = ["No assignments created"]
    }

    return <div className='notification-text'>{messageArray}</div>
  }

  //Separated from the upsertion success message as there are slight changes to wording,
  //only one quest can be deleted at a time, and eventually,
  //we want to split deletion into its own component.
  getDeletionSuccessMessage = (assignments)=> {
    const classAssignments = _.filter(assignments, (a)=> _.isNumber(a.sectionAssignmentId))
    const individualAssignments = _.filter(assignments, (a)=> !_.isNumber(a.sectionAssignmentId) && _.isNumber(a.studentId))

    const hasSelfAssignment = !_.isEmpty(_.filter(assignments, (a)=> _.isString(a.userId)))
    const hasClassAssignments = !_.isEmpty(classAssignments)
    const hasIndividualAssignments = !_.isEmpty(individualAssignments)

    const classAssignmentClassesCount = _.compact(_.uniq(_.map(classAssignments, (a)=> a.sectionAssignmentId))).length
    const individualStudentCount = _.compact(_.uniq(_.map(individualAssignments, (a)=> a.studentId || a.userId))).length


    const individualStudentString = individualStudentCount + " individual student" + (individualStudentCount > 1 ? "s" : "")
    const classCountString = classAssignmentClassesCount + " class" + (classAssignmentClassesCount > 1 ? "es":"")

    let messageArray = [<b>1 assignment</b>," deleted for "]

    if(hasClassAssignments){
      messageArray.push(<b>{classCountString}</b>)

      if(hasIndividualAssignments){
        if(hasSelfAssignment){
        messageArray = messageArray.concat([", ", <b>{individualStudentString}</b>,", and ", <b>yourself</b>])
        } else {
          messageArray = messageArray.concat([" and ", <b>{individualStudentString}</b>])
        }
      } else if(hasSelfAssignment){
        messageArray = messageArray.concat([" and ", <b>yourself.</b>])
      }
    } else if(hasIndividualAssignments){
      messageArray.push(<b>{individualStudentString}</b>)

      if(hasSelfAssignment){
        messageArray = messageArray.concat([" and ", <b>yourself.</b>])
      }
    } else if(hasSelfAssignment){
          messageArray.push(<b>yourself.</b>)
    } else {
      messageArray = ["No assignments created"]
    }

    return <div className='notification-text'>{messageArray}</div>
  }


  render() {
    return(
      <AssignmentPopup
        {...this.props}
        {...this.state}
        setSelectedDate={this.setSelectedDate}
        checkTextDate={this.checkTextDate}
        setSelectedIndex={this.setSelectedIndex}
        resetForm={this.resetForm}
        onSubmitUpsertion={this.onSubmitUpsertion}
        onSubmitDelete={this.onSubmitDeletion}
        resolveDecision={this.resolveDecision}
        getConflictMessage={this.getConflictMessage}
        getDeletionSuccessMessage={this.getDeletionSuccessMessage}
        getSuccessMessage={this.getSuccessMessage}
        resetNotifications={this.resetNotifications}
        onAssigneeChange={this.onAssigneeChange}
      />
    );
  }
}

export default AssignmentPopupContainer;
